import axios from '@/plugins/axios';

const initialState = {
  list: [],
  permissionsList: [],
};

const getters = {
  permissions({ permissionsList }) {
    return permissionsList.reduce((res, item) => {
      const copy = { ...res };
      const isExisting = item.category.id in res;

      if (!isExisting) {
        copy[item.category.id] = {
          name: item.category.name,
          items: [],
        };
      }

      copy[item.category.id].items.push(item);
      return copy;
    }, {});
  },
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get('/roles', {
        params,
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      commit('setList', data.data.items);

      return data;
    } catch (error) {
      return error;
    }
  },

  async fetchRole({ commit }, id) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get(`/roles/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      commit('setRole', data.data);

      return data;
    } catch (error) {
      return error;
    }
  },

  async fetchPermissions({ commit }, params) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get('/permissions', {
        params,
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      commit('setPermissionsList', data.data.items);
      return data;
    } catch (error) {
      return error;
    }
  },

  async addNew(_, params) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.post('/roles', params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async updateItem({ dispatch }, { id, params }) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const me = JSON.parse(localStorage.getItem('me'));

      await axios.put(`/roles/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      if (me.role_permissions.id === Number(id)) {
        dispatch('auth/logOut', null, { root: true });
        window.location.href = '/auth/login';
      }

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async deleteItem(_, id) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.delete(`/roles/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async restoreItem(_, id) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.get(`/roles/restore/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return error;
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },

  setPermissionsList(state, payload) {
    state.permissionsList = payload;
  },

  setRole(state, payload) {
    state.role = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
